// Local-time YMD formatting.
//
// `Date.prototype.toISOString().split('T')[0]` is a footgun: it converts the
// Date to UTC before slicing the date portion, which silently shifts the
// returned day by one in any timezone east of UTC. In CEST (UTC+2), local
// May 1 00:00 becomes UTC April 30 22:00, so naïve "format today as YMD"
// helpers return yesterday's date for any caller running in the night.
//
// `formatDateLocal()` reads the local Date components directly, so the
// returned string matches what the user sees on their wall clock —
// regardless of timezone.

export function formatDateLocal(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

/**
 * YMD for today, in the user's local timezone.
 */
export function todayLocal(): string {
    return formatDateLocal(new Date());
}
